import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import _ from "../../utils/lodashUtils"
import { invitePartnerToChat } from "../../redux/actionCreators/invitePeople"
import { Button, TextTag as Text } from "../../atoms"
import "./Nudge.scss"
import { fetchPartnerDetails } from "../../redux/actionCreators/invitePeople"
import { PARTNER_OFFLINE, NUDGE_BUTTON } from "../../constants/messages"
import { FirebaseContext, FIREBASE_STATE_KEYS } from "../../firebase"
import {
  getGenderSpecificMessage,
  getPartnerNameorNickName,
  getNudgeState,
} from "../../utils/helpers"

// TODO: Update the UI with Name and gender details
const Nudge = (props) => {
  const { partnerState, dateState, userState } = React.useContext(
    FirebaseContext
  )
  let partner = _.get(partnerState, "userDetails", {})
  let nickName = _.get(props.invite, "nickName")
  const activeScreen = _.get(userState, FIREBASE_STATE_KEYS.ACTIVE_SCREEN)
  const partnerName = getPartnerNameorNickName(
    partnerState,
    props.partnerDetails.partner,
    props.invite.partnerDetails
  )
  useEffect(() => {
    fetchPartnerDetails()
  }, [])

  const nudgePartner = () => {
    const nudgeState = getNudgeState(activeScreen)
    props.invitePartnerToChat(partner.display_name, nudgeState)
  }

  return (
    <div id="ChatPage">
      <section className="date-chat-window">
        <div className="nudge-container">
          <div className="nudge-label">
            <Text>
              {PARTNER_OFFLINE(
                partnerName,
                getGenderSpecificMessage(partner.gender)
              )}
            </Text>
          </div>
          <div className="nudge-btn-container">
            <Button
              className="nudge-btn"
              btnType="primary"
              btnSize="large"
              onClick={nudgePartner}
            >
              {NUDGE_BUTTON}
            </Button>
          </div>
        </div>
      </section>
    </div>
  )
}
const mapStateToProps = (state) => ({
  user: state.auth.user,
  partnerDetails: state.auth,
  invite: state.invitePeople,
  partner: state.partner,
})

export default withRouter(
  connect(mapStateToProps, { invitePartnerToChat, fetchPartnerDetails })(Nudge)
)
